<script lang="ts" setup name="SailingScheduleTradeLaneHorizontalScrollButton">
import Icon from '~/components/Icon.vue';

const { forward = false } = defineProps<{
  forward?: boolean;
}>();
</script>

<template>
  <button
    type="button"
    class="pointer-events-auto grid h-09 w-09 place-items-center rounded-full bg-white shadow-md"
  >
    <Icon
      class="text-primary-8"
      :icon="forward ? 'ic:baseline-arrow-forward' : 'ic:baseline-arrow-back'"
    />
  </button>
</template>
